import { useState } from 'react';

import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';
import Stack from '@zenbusiness/zui/Stack';
import useBreakpoints from '@zenbusiness/zui/useBreakpoints';
import PropTypes from 'prop-types';

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import MobileDrawer from '#client/components/MobileDrawer';

import { MenuStyled, ButtonStyled } from './AccountDetailButton.style';
import AccountDetails from './AccountDetails';

export default function AccountDetailButton({ accountDetails }) {
  const {
    sizes: { isMobile }
  } = useBreakpoints();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const buttonPressedTracker = useButtonPressedCallback({
    elementName: 'account_details_banking_widget',
    elementText: open ? 'Hide account details' : 'Show account details',
    appPageName: 'active_banking_dashboard'
  });

  const handleOpen = (event) => {
    buttonPressedTracker();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const AccountDetailsContent = (
    <Stack gap="4px">
      <AccountDetails accountDetails={accountDetails} />
    </Stack>
  );

  return (
    <>
      <ButtonStyled
        aria-controls={open ? 'account-details-menu' : undefined}
        aria-expanded={open}
        aria-haspopup
        color="info"
        disableRipple
        icon={open ? <VisibilityOffIcon /> : <VisibilityIcon />}
        id="account-details-button"
        onClick={handleOpen}
        size="small"
        sx={{
          width: 'fit-content'
        }}
        variant="text"
      >
        {open ? 'Hide account details' : 'Show account details'}
      </ButtonStyled>

      {isMobile ? (
        open && (
          <MobileDrawer
            aria-labelledby="account-details-button"
            handleClose={handleClose}
            id="account-details-menu"
          >
            {AccountDetailsContent}
          </MobileDrawer>
        )
      ) : (
        <MenuStyled
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
          disableAutoFocus
          id="account-details-menu"
          MenuListProps={{
            'aria-labelledby': 'account-details-button'
          }}
          onClose={handleClose}
          open={open}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
        >
          {AccountDetailsContent}
        </MenuStyled>
      )}
    </>
  );
}

AccountDetailButton.propTypes = {
  accountDetails: PropTypes.shape({
    accountNumber: PropTypes.string.isRequired,
    routingNumber: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    firstAddressLine: PropTypes.string.isRequired,
    secondAddressLine: PropTypes.string.isRequired
  }).isRequired
};
